const DRAFT_PREVIEW_COMMERCE_LINK_KINDS = new Set([
  "order",
  "reservation",
  "club",
  "account",
]);

/** Client-safe: no Node builtins. Used by public chrome to hide commerce CTAs. */
export function isDraftPreviewCommerceLinkKind(kind: string): boolean {
  return DRAFT_PREVIEW_COMMERCE_LINK_KINDS.has(kind);
}
